

export default class CustomViewSettings {


    constructor(data:any) {

    }

}